import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  required,
} from 'react-admin';

export const ContactGroupCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput
        source="name"
        validate={[required()]}
        fullWidth
      />
      <BooleanInput
        source="isActive"
        defaultValue={true}
      />
      <NumberInput
        source="sortOrder"
        defaultValue={0}
        min={0}
      />
      <ArrayInput source="contacts" label="Контакты">
        <SimpleFormIterator inline>
          <TextInput
            source="name"
            label="Название"
            validate={[required()]}
            helperText="Название контакта"
          />
          <TextInput
            source="mapLink"
            label="Ссылка на карту"
            helperText="URL ссылка на карту"
          />
          <TextInput
            source="phone"
            label="Телефон"
            helperText="Номер телефона"
          />
          <TextInput
            source="email"
            label="Email"
            helperText="Электронная почта"
          />
          <TextInput
            source="address"
            label="Адрес"
            helperText="Физический адрес"
            multiline
          />
          <TextInput
            source="workingHours"
            label="Часы работы"
            helperText="Режим работы"
          />
          <BooleanInput
            source="isActive"
            label="Активен"
            defaultValue={true}
          />
          <NumberInput
            source="sortOrder"
            label="Порядок сортировки"
            defaultValue={0}
            min={0}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);
